export default __webpack_public_path__ + "static/media/talking-with-your-partner.a492dec3.svg";